<template>
  <div class="myRegistration">
        <h3 class="containner-title">{{$t("message.alert_expiration")}}</h3>
        <div class="card-body border" style="background-color: #f1f1f1;">
            <form class="form" v-on:submit.prevent>
              <div class="row mb-2">
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.last_name")}}</label>
                  <input type="text" 
                      class="form-control" 
                      v-model="search.lastname"
                      :placeholder="$t('message.last_name')" aria-label="Last name">
                </div>
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.first_name")}}</label>
                  <input type="text" 
                    class="form-control" 
                    v-model="search.firstname"
                    :placeholder="$t('message.first_name')" 
                    aria-label="First name">
                </div>
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.phone")}}</label>
                  <input type="text" 
                    class="form-control" 
                    v-model="search.phone"
                    :placeholder="$t('message.phone')">
                </div>
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.gender")}}</label>
                  <select
                    class="form-select"
                    v-model="search.gender"
                    :placeholder="$t('message.gender')"
                  >
                    <option value="">Choose...</option>
                    <option value="1">{{$t("message.male")}}</option>
                    <option value="2">{{$t("message.female")}}</option>
                  </select>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.business_type")}}</label>
                  <select
                    class="form-select"
                    v-model="search.type_business"
                  >
                    <option value="" selected>Choose...</option>
                    <option value="1">{{$t("message.stock_business")}}</option>
                    <option value="4">{{$t("message.found")}}</option>
                    <option value="2">{{$t("message.derivative_business")}}</option>
                    <option value="3">{{$t("message.public")}}</option>
                  </select>
                </div>
                <div class="col">
                  <label for="company" class="form-label">{{$t("message.company")}}</label>
                  <input type="text" 
                      class="form-control" 
                      v-model="search.company"
                      placeholder="company">
                </div>
                <div class="col">
                  <label for="company" class="form-label">{{$t("message.expiration_date")}}</label>
                  <select
                    class="form-select"
                    v-model="search.expiration_query"
                    placeholder="Status"
                  >
                    <option value="">{{$t("message.all_alerts")}}</option>
                    <option value="1">បានផុតកំណត់</option>
                    <option value="2">ជិតផុតកំណត់រយះពេល៣ខែ</option>
                  </select>
                </div>
               
                <div class="col">
                  <label for="company" class="form-label">{{$t("message.status")}}</label>
                  <select
                    class="form-select"
                    v-model="search.status"
                    placeholder="Status"
                  >
                    <option value="">Choose...</option>
                    <option value="0">{{$t("message.inactive")}}</option>
                    <option value="1">{{$t("message.active")}}</option>
                  </select>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-12" style="text-align: right;margin-top: 5px;">
                  <button class="btn btn-warning me-2" @click="sendAlertToAll">
                    <i class="fas fa-envelope-open-text"></i> {{$t("message.alert_all")}}
                  </button>
                  <button class="btn btn-success me-2" @click="exportExcel">
                    <i class="fas fa-file-excel"></i> {{$t("message.export")}}
                  </button>
                  <button class="btn btn-danger" @click="searchAction">
                    <i class="fas fa-search"></i> {{$t("message.search")}}
                  </button>
                </div>
              </div>
            </form>
        </div>
        <div class="row">
          <label class="text-end fs-5 fw-bold p-2">{{$t("message.total")}}: <span class="text-primary">{{listRegister.total}}</span></label> 
        </div>
        <table class="table table-bordered table-striped">
          <thead class="table-dark">
            <tr>
              <th class="align-middle text-center">#</th>
              <th class="align-middle text-center"></th>
              <th class="align-middle">{{$t("message.name")}}</th>
              <th class="align-middle text-center">{{$t("message.company")}}</th>
              <th class="align-middle text-center" style="width:250px;">{{$t("message.business_type")}}</th>
              <th class="align-middle text-center">{{$t("message.expiration_date")}}</th>
              <th class="align-middle text-center">{{$t("message.status")}}</th>
              <th class="align-middle text-center">{{$t("message.action")}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in listRegister.data" :key="item.id">
              <th class="align-middle text-center" style="vertical-align: middle;width: 30px;">{{index+1}}</th>
              <td class="text-center" style="vertical-align: middle;">
                <img v-if="item.participant.avatar" class="avatar" :src=item.participant.avatar />
                <img v-else class="avatar" src="../../../assets/images/usericone.png" />
              </td>
              <td style="vertical-align: middle;">
                 <label class="fw-bold" v-if="item.participant.lastname && item.participant.firstname">
                    {{item.participant.lastname + ' ' + item.participant.firstname}} ({{item.participant.lastname_en + ' ' + item.participant.firstname_en}})
                  </label>
                  <label class="fw-bold" v-else>
                    {{item.participant.lastname_en + ' ' + item.participant.firstname_en}}
                  </label>
                  <br/>
                <label class="fw-bold">{{$t("message.gender")}}</label>: {{item.participant.gender==1 ? "ប្រុស": item.participant.gender==2 ? "ស្រី" : ""}}<br/>
                <label class="fw-bold">{{$t("message.dob")}}</label>: {{item.participant.dob}}<br/>
                <label class="fw-bold">{{$t("message.phone")}}</label>: {{item.participant.phone}}<br/>
                <label class="fw-bold">{{$t("message.email")}}</label>: {{item.participant.email}}<br/>
                <label class="fw-bold">{{$t("message.nationality")}}</label>: {{item.participant.nationality_name}}<br/>
                <label class="fw-bold">{{$t("message.alert_sent")}}</label>: <span class="badge bg-secondary">{{item.alert_number || 0}}</span><br/>
                <span v-if="item.alert_logs && item.alert_logs.length" class="text-muted small">
                  <div class="small text-secondary fw-bold mb-1 mt-1">{{$t("message.reminder")}}:</div>
                  <div v-for="(log, idx) in item.alert_logs" :key="idx" class="small text-muted border-start border-2 ps-2 mb-1" style="border-color: #ffc107 !important; font-size: 0.85em; line-height: 1.2;">
                    {{ log.alert_date }} {{$t("message.by")}} {{ log.alert_by_name }}
                  </div>
                </span>
              </td>
              <td class="align-middle text-center" style="vertical-align: middle;">{{item.participant.company_name }}</td>
              <td class="align-middle text-center" style="vertical-align: middle;">
                {{item.type_business_name}}
              </td>
              <td class="text-center align-middle" style="vertical-align: middle;">
                <span v-if="isExpired(item.license_expiry_date)" class="badge bg-danger p-2">
                  <i class="fas fa-exclamation-circle me-1"></i>
                  {{item.license_expiry_date}} ({{$t("message.expired")}})
                </span>
                <span v-else-if="isExpiringSoon(item.license_expiry_date)" class="badge bg-warning text-dark p-2">
                  <i class="fas fa-exclamation-triangle me-1"></i>
                  {{item.license_expiry_date}} ({{$t("message.expiring_soon")}})
                </span>
                <span v-else class="badge bg-success p-2">
                  {{item.license_expiry_date}}
                </span>
              </td>
              <td class="text-center align-middle">{{item.status ? $t("message.active") : $t("message.inactive")}}</td>
              <td class="text-center align-middle">
                <router-link class="btn btn-info me-1" :to="{ name: 'showParticipant' , params:{id:item.id}, query: {viewOnly: true}}"><i class="far fa-eye text-white"></i></router-link>
                <button class="btn btn-warning" @click="sendEmailAlert(item)" :disabled="item.sendingAlert">
                  <i class="fas" :class="item.sendingAlert ? 'fa-spinner fa-spin' : 'fa-envelope'"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination v-model="search.page" 
            :records="total" 
            :per-page="search.limit" 
            @paginate="setPage($event)"/>
      </div>
</template>
<script>
import Pagination from 'v-pagination-3';
import axios from "@/axios";
export default {
  data() {
    return {
      search: {
        firstname: '',
        lastname: '',
        phone: '',
        gender: '',
        company: '',
        expiration_query: '',
        status: '',
        nationality: '',
        page:1,
        limit:50
      }
      ,total:0
      ,listRegister: {}
    };
  },
  computed: { 
    getBusinessType(){
      return (t) => {
        switch (t){
            case '1':
            case 1:
                return this.$t("message.stock_business");
            case '2':
            case 2:
                return this.$t("message.derivative_business");
            case '19':
            case 19:
                return this.$t("message.public") + ' - ' + this.$t("message.stock_business");
            case 20:
            case '20':
                return this.$t("message.public") + ' - ' + this.$t("message.derivative_business");
            default:
                return t;
        }
      }
    }
  },
  methods: {
    showLoader() {
      return this.$loading.show({
        container: this.$refs.formContainer,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    searchAction(){
      this.loadData();
    },
    async loadData(){
      let loader = this.showLoader();
      let queryParams = { ...this.search };
      if (!queryParams.expiration_query) {
        queryParams.expiration_query = '2,1';
      }
      const respone = await axios.get("list-all-approve-person", {
        params: queryParams,
        headers: {
          Authorization: "Bearer " + this.$store.getters.getAuthToken
        }
      });
      if (respone.status == 200) {
        this.listRegister = respone.data;
        if (this.listRegister.data) {
          this.listRegister.data = this.listRegister.data.map(item => ({
            ...item,
            sendingAlert: false
          }));
        }
        this.total = respone.data.total;
      }
      loader.hide();
    },
    async sendEmailAlert(item) {
      this.$swal
        .fire({
          title: "Are you sure you want to send email alert?",
          showCancelButton: true,
          confirmButtonText: this.$t("message.yes"),
          cancelButtonText: this.$t("message.cancel")
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            item.sendingAlert = true;
            try {
              const response = await axios.post(`alert-expiration-email/${item.id}`, {}, {
                headers: {
                  Authorization: "Bearer " + this.$store.getters.getAuthToken
                }
              });
              if (response.status === 200) {
                item.alert_number = response.data.alert_number;
                item.alert_date = response.data.alert_date;
                item.alert_by_name = response.data.alert_by_name;
                item.alert_logs = response.data.alert_logs;
                this.$toast.open({
                  message: "Alert email sent successfully!",
                  type: "success",
                  duration: 5000,
                  dismissible: true,
                  position: "top-right"
                });
              }
            } catch (error) {
              this.$toast.open({
                message: error.response?.data?.message || "Failed to send email alert",
                type: "error",
                duration: 5000,
                dismissible: true,
                position: "top-right"
              });
            } finally {
              item.sendingAlert = false;
            }
          }
        });
    },
    async sendAlertToAll() {
      this.$swal
        .fire({
          title: "Are you sure you want to send email alert to ALL matching participants?",
          showCancelButton: true,
          confirmButtonText: this.$t("message.yes"),
          cancelButtonText: this.$t("message.cancel")
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let loader = this.showLoader();
            let queryParams = { ...this.search };
            if (!queryParams.expiration_query) {
              queryParams.expiration_query = '2,1';
            }
            try {
              const response = await axios.post("alert-all-expiration-emails", queryParams, {
                headers: {
                  Authorization: "Bearer " + this.$store.getters.getAuthToken
                }
              });
              if (response.status === 200) {
                this.$toast.open({
                  message: response.data.message || "Alert emails sent successfully!",
                  type: "success",
                  duration: 5000,
                  dismissible: true,
                  position: "top-right"
                });
                this.loadData();
              }
            } catch (error) {
              this.$toast.open({
                message: error.response?.data?.message || "Failed to send email alerts",
                type: "error",
                duration: 5000,
                dismissible: true,
                position: "top-right"
              });
            } finally {
              loader.hide();
            }
          }
        });
    },
    async exportExcel(){
      this.$swal
        .fire({
          title: "តើអ្នកចង់ export excel មែនទេ?",
          showCancelButton: true,
          confirmButtonText: `យល់ព្រម`,
          cancelButtonText: `បោះបង់`
        })
        .then(async (result) => {
          if (result.isConfirmed) {
              let loader = this.showLoader();
              let queryParams = { ...this.search };
              if (!queryParams.expiration_query) {
                queryParams.expiration_query = '2,1';
              }
              const response = await axios.post("export-alert-expiration", queryParams, {
                headers: {
                  Authorization: "Bearer " + this.$store.getters.getAuthToken
                },
                responseType: "blob"
              });
              const type = response.headers["content-type"];
              const blob = new Blob([response.data], {
                type: type,
                encoding: "UTF-8"
              });
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = "alert-expiration.xlsx";
              link.click();
              loader.hide();
          }
        });
    },
    setPage($event){
      this.search.page=$event;
      this.loadData();
    },
    isExpired(dateStr) {
      if (!dateStr) return false;
      const parts = dateStr.split('/');
      if (parts.length !== 3) return false;
      const date = new Date(parts[2], parts[1] - 1, parts[0]);
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);
      return date < now;
    },
    isExpiringSoon(dateStr) {
      if (!dateStr) return false;
      const parts = dateStr.split('/');
      if (parts.length !== 3) return false;
      const date = new Date(parts[2], parts[1] - 1, parts[0]);
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);
      
      const diffTime = date - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      return diffDays >= 0 && diffDays <= 90;
    }
  },
  created() {
    this.loadData();
  },
  mounted() {
    
  }, components: {
    Pagination
  }
};
</script>
<style scoped>
div.content {
  margin-left: 200px;
  padding: 25px;
  height: auto;
  margin-top: 0;
}

@media screen and (max-width: 700px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
  .sidebar a {
    float: left;
  }
  div.content {
    margin-left: 0;
  }
}

.footer {
  margin-left: 200px;
}
</style>
